export const toastProps = {
  isLoading: false,
  autoClose: 10000,
  closeButton: true
}
